<div class="header-top home-style">
    <div class="container">
        <ul>
            <li>
                <i class="fas fa-phone"></i>
                <a href="tel:+33 9 55 60 24 26">+33 9 55 60 24 26</a>
            </li>
            <li>
                <i class="fas fa-envelope"></i>
                <a href="mailto:contact@enovsky.com">contact@enovsky.com</a>
            </li>
        </ul>
    </div>
</div>
<mat-sidenav-container class="home-style" style="height: 100vh;">
    <mat-sidenav #sidenav class="mat-sidenav-style">
      <mat-nav-list>
        <div style="width: 100%; height: 100px; display: flex; justify-content: center;">
            <img src="assets/logos/logo_enovsky.png" style="height: 100px;">
        </div>
        <div style="padding-top: 2rem;">
            <mat-list-item [ngClass]="{'active-page' : activePage == 'subscribe'}" (click)="showHidePage('subscribe')">
                <div fxLayout="row" fxLayoutAlign="space-between center" > 
                    <mat-icon class="icon-leading" aria-hidden="false" fontIcon="shopping_cart"></mat-icon>
                    <span class="text">Abonnement</span>
                    <mat-icon class="icon-trailing" aria-hidden="false" fontIcon="arrow_forward_ios"></mat-icon>
                </div>
            </mat-list-item>
            <mat-list-item [ngClass]="{'active-page' : activePage == 'who_we_are'}" (click)="showHidePage('who_we_are')">
                <div fxLayout="row" fxLayoutAlign="space-between center" > 
                    <mat-icon class="icon-leading" aria-hidden="false" fontIcon="groups"></mat-icon>
                    <span class="text">Qui Sommes-Nous</span>
                    <mat-icon class="icon-trailing" aria-hidden="false" fontIcon="arrow_forward_ios"></mat-icon>
                </div>
            </mat-list-item>
            <mat-list-item [ngClass]="{'active-page' : activePage == 'functionality'}" (click)="showHidePage('ower_solutions')">
                <div fxLayout="row" fxLayoutAlign="space-between center" > 
                    <mat-icon class="icon-leading" aria-hidden="false" fontIcon="emoji_objects"></mat-icon>
                    <span class="text">Nos Solutions</span>
                    <mat-icon class="icon-trailing" aria-hidden="false" fontIcon="arrow_forward_ios"></mat-icon>
                </div>
            </mat-list-item>
            <mat-list-item [ngClass]="{'active-page' : activePage == 'functionality'}" (click)="showHidePage('functionality')">
                <div fxLayout="row" fxLayoutAlign="space-between center" > 
                    <mat-icon class="icon-leading" aria-hidden="false" fontIcon="settings"></mat-icon>
                    <span class="text">Fonctionnalités</span>
                    <mat-icon class="icon-trailing" aria-hidden="false" fontIcon="arrow_forward_ios"></mat-icon>
                </div>
            </mat-list-item>
        </div>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content style="overflow: hidden;">
      <div >
        <mat-toolbar class="mat-elevation-z2 toolbar-style">
            <mat-icon style="cursor: pointer;" aria-hidden="false" fontIcon="menu" title="Mop" (click)="sidenav.open()"></mat-icon>
            <div class="spacer"></div>
            <div class="spacer"></div>
            <a href="https://virtualschool.enovsky.com/feedback/EVK026" style="text-decoration: none;" class="toolbar-menu" target="_blank" rel="noopener noreferrer">Votre Avis</a>
            <a href="https://virtualschool.enovsky.com/subscribe" style="text-decoration: none;" class="toolbar-menu" target="_blank" rel="noopener noreferrer">Souscrire un Abonnement</a>
            <!-- <a [routerLink]="'data-deletion'" [ngClass]="{'active-page' : currentRoute == 'data-deletion'}" class="toolbar-menu" (click)="shareUserData()">Secondary (VCL)</a> -->
            <a [routerLink]="''" class="dropdown profile">
                <img src="assets/logos/icon_enovsky.png">
            </a>
            
        </mat-toolbar>
        
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
</mat-sidenav-container>